export default class ClipBoard {
	constructor(el = null) {
		if (el) {
			this.copies = el.querySelectorAll('[data-copy]');
		} else {
			this.copies = document.querySelectorAll('[data-copy]');
		}

		[...this.copies].forEach(element => {
			const btn = element.querySelector('button');
			btn?.addEventListener('click', e => {
				e.preventDefault();
				this.copy(element);
			});
		});
	}

	copy(element) {
		const input = element.querySelector('input');
		input.select();
		input.setSelectionRange(0, 99999);
		document.execCommand('copy');
	}
}
